/**
 * @license
 * Copyright 2022 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
/** Any Custom HTML element. Some elements directly implement this interface, while others implement it via an interface that inherits it. */
export class BaseComponent extends HTMLElement {
}
